// extracted by mini-css-extract-plugin
module.exports = {"root":"tasks_root__1T3nf","minWidthTd":"tasks_minWidthTd__3gT5F","selected":"tasks_selected__3noxU","rot":"tasks_rot__3XZLJ"};